import { render, staticRenderFns } from "./DeleteForestConfirmModal.vue?vue&type=template&id=58f8a1f0&scoped=true&"
import script from "./DeleteForestConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DeleteForestConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteForestConfirmModal.vue?vue&type=style&index=0&id=58f8a1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8a1f0",
  null
  
)

export default component.exports